import * as React from 'react';
import { StyleSheet } from 'react-native';
import { CardElement, Card, CardProps } from '@ui-kitten/components';

// interface CardProps {}

export const PoallCard = (props: CardProps): CardElement => {
    const passedStyle = props.style ? props.style : undefined;

    return (
        <Card {...props} style={[poallCardStyles.shadow, passedStyle]} />
    );
};

export const PoallCardListItem = (props: CardProps): CardElement => {
    const passedStyle = props.style ? props.style : undefined;

    return (
        <Card {...props} style={[poallCardStyles.container, passedStyle]} />
    );
};



export default PoallCard;

export const poallCardStyles = StyleSheet.create({
    container: {
        paddingBottom: 16, // match card
        paddingHorizontal: 24, // match card
        borderRadius: 0,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderColor: 'rgb(228, 233, 242)'
    },
    shadow2: {
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.23,
        shadowRadius: 2.62,
        
        elevation: 4,
    },
    shadow: {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.18,
        shadowRadius: 1.00,

        elevation: 1,
    }
});
